const ConfirmationModal = ({
  show,
  onClose,
  onConfirm,
  title,
  message,
  loading,
}) => {
  if (!show) return null;

  return (
    <div
      className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
      style={{ zIndex: 10000, background: "rgba(0,0,0,0.6)" }}
      onClick={onClose}
    >
      <div
        className="bg-white rounded-16 shadow-lg position-relative"
        style={{
          maxWidth: "450px",
          width: "90%",
          padding: "40px 32px 32px 32px",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="text-center mb-24">
          <div
            className="w-80 h-80 rounded-circle bg-danger-50 flex-center mx-auto mb-16"
            style={{ animation: "pulse 2s infinite" }}
          >
            <i
              className="ph-fill ph-warning text-danger-600"
              style={{ fontSize: "48px" }}
            />
          </div>
          <h4 className="text-xl fw-bold text-gray-900 mb-8">{title}</h4>
          <p className="text-md text-gray-600">{message}</p>
        </div>

        <div className="d-flex align-items-center justify-content-center gap-3">
          <button
            type="button"
            onClick={onClose}
            disabled={loading}
            style={{
              padding: "12px 32px",
              border: "1px solid #d1d5db",
              background: "white",
              borderRadius: "50px",
              fontWeight: "600",
              cursor: "pointer",
              color: "#374151",
              transition: "all 0.2s",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = "#f9fafb";
              e.currentTarget.style.borderColor = "#9ca3af";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = "white";
              e.currentTarget.style.borderColor = "#d1d5db";
            }}
          >
            Cancel
          </button>{" "}
          &nbsp;&nbsp;
          <button
            type="button"
            onClick={onConfirm}
            disabled={loading}
            style={{
              padding: "12px 32px",
              border: "none",
              background: "#dc2626",
              borderRadius: "50px",
              fontWeight: "700",
              cursor: "pointer",
              color: "white",
              display: "flex",
              alignItems: "center",
              gap: "8px",
              transition: "all 0.2s",
            }}
            onMouseEnter={(e) => (e.currentTarget.style.background = "#b91c1c")}
            onMouseLeave={(e) => (e.currentTarget.style.background = "#dc2626")}
          >
            {loading ? (
              <>
                <i className="ph ph-spinner animate-spin" />
                Deleting...
              </>
            ) : (
              <>
                <i className="ph-bold ph-trash" />
                Delete
              </>
            )}
          </button>
        </div>
      </div>

      <style jsx>{`
        @keyframes pulse {
          0%,
          100% {
            transform: scale(1);
            opacity: 1;
          }
          50% {
            transform: scale(1.05);
            opacity: 0.8;
          }
        }
        .animate-spin {
          animation: spin 1s linear infinite;
        }
        @keyframes spin {
          from {
            transform: rotate(0deg);
          }
          to {
            transform: rotate(360deg);
          }
        }
      `}</style>
    </div>
  );
};

export default ConfirmationModal;
